module.exports = __webpack_public_path__ + "static/media/email-icon-grey.d9de4670.svg";